import { equals } from 'ramda';
import { getStatusCode, getErrorCode } from '../selectors/error';
import { ERROR_CODES } from '../enums';

export const isRequestError400 = state => getStatusCode(state) === 400;
export const isRequestError403 = state => getStatusCode(state) === 403;
export const isRequestError404 = state => getStatusCode(state) === 404;
export const isRequestError409 = state => getStatusCode(state) === 409;
export const isRequestError501 = state => getStatusCode(state) === 501;

export const isClaimFnolMissing = state =>
  isRequestError409(state) && equals(getErrorCode(state), ERROR_CODES.CLAIM_FNOL_MISSING);
export const isOTPNotValid = state => isRequestError403(state) && equals(getErrorCode(state), ERROR_CODES.OTP_INVALID);
